import React, { useEffect } from "react";
import { formatNumber } from "@/util/sums";
import ColFormValueSlider from "./ColFormValueSlider";
import { useController, useFormContext, useWatch } from "react-hook-form";
import ControlledFormField from "@/model/interface/ControllerRangeSlider";
import clamp from "@/util/clamp";
import { CalculatorField } from "@/model/interface/CalculatorTypes";

const getDepositBoostShare = (depsArray: number[]) => {
  const [depositValue] = depsArray;

  const minAmount = depositValue * 0.1;
  const maxAmount = depositValue / 2;
  const newDepositBoostValue = depositValue / 2;

  return {
    defaultValue: 125000,
    minAmount,
    maxAmount,
    value: clamp(newDepositBoostValue, minAmount, maxAmount),
  };
};

const fieldName = CalculatorField.DepositNeeded;
const fieldsWatched = [CalculatorField.DepositValue];
const DepositBoostShare: React.FC<ControlledFormField> = ({ fieldPrefix }) => {
  const targetName = [fieldPrefix, fieldName].filter(Boolean).join(".");
  const dependencies = fieldPrefix ? fieldsWatched.map((field) => `${fieldPrefix}.${field}`) : fieldsWatched;

  const { control, setValue } = useFormContext();
  const depsArray = useWatch({ control, name: dependencies });

  const { value, defaultValue, ...minMaxParams } = getDepositBoostShare(depsArray);

  const { field } = useController({
    control,
    name: targetName,
    defaultValue,
  });

  useEffect(() => {
    if (!value) return;
    setValue(targetName, value);
  }, [depsArray]);

  return (
    <ColFormValueSlider
      title="Upfront boost needed"
      step={1000}
      value={field.value}
      {...minMaxParams}
      rightColumnValue={field.value}
      rightColumnFormatFunction={(value) => `$${formatNumber(value, 0, true)}`}
      onChange={field.onChange}
      onFinalChange={field.onChange}
    />
  );
};

export default DepositBoostShare;
